<style scoped>
.comp-service-area {
  display: inline-block;
  max-width: 192px;
}
</style>

<template>
  <div class="comp-service-area">
    <el-cascader placeholder="筛选工作服务区"
      :key="keyIndex"
      v-model="value"
      :options="areaInfos"
      :size="size"
      :show-all-levels="showAllLevels"
      :filterable="true"
      :clearable="clearable"
      :props="{ expandTrigger: 'hover', value: 'name', label: 'name', children: 'children' }"
      @change="handleChange"></el-cascader>
  </div>
</template>

<script>
export default {
  name: 'CompServiceArea',
  props: {
    size: {
      type: String,
      default: 'medium'
    },
    clearable: {
      type: Boolean,
      default: true
    },
    showAllLevels: {
      type: Boolean,
      default: true
    },
    options: {
      type: Array,
      default: () => []
    },
    isCurrentArea: {
      type: Boolean,
      default: false
    },
    isReset: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
        keyIndex: 0,
        value: [],
        oldAreaData: [],
        areaInfos: []
    }
  },
  watch: {
    isCurrentArea: {
      handler(newVal, oldVal) {
        // this.value = newVal ? [this.$store.getters.servicePlatform, this.$store.getters.serviceArea] : this.value || []
      },
      immediate: true
    },
    options: {
      handler(newVal, oldVal) {
        this.keyIndex++
        if (newVal.length > 0) {
          this.oldAreaData = newVal
          this.areaInfos = newVal.map(item => {
            return item.areaInfo
          })
          this.tranceAreaInfo(this.areaInfos)
        } else {
          this.oldAreaData = []
          this.areaInfos = []
        }
        // 初始化默认值
        this.getDefaultArea()
      },
      deep: true
    },
    isReset(newVal) {
      console.log(newVal)
      if (newVal) {
        this.value = []
      }
    }
  },
  methods: {
    getDefaultArea() {
      if (!this.value || this.value.length <= 0) {
        this.value = this.isCurrentArea ? [this.$store.getters.servicePlatform, this.$store.getters.serviceArea] : []
      }
      console.log(this.value)
    },
    tranceAreaInfo(areaInfos) {
      // 分组，platform相同的合并到一个数组
      let platformAreas = {}
      areaInfos.forEach(point => {
        if (!platformAreas[point.platform]) {
          platformAreas[point.platform] = []
        }
        platformAreas[point.platform].push(point)
      })
      // 合并到一个数组
      let newAreaInfos = []
      for (let platform in platformAreas) {
        newAreaInfos.push({
          name: platform,
          platform: platform,
          children: platformAreas[platform]
        })
      }
      this.areaInfos = newAreaInfos
    },
    handleChange(value) {
      this.$emit('change', value)
    }
  }
}
</script>
